import styles from "./About.module.css";

export function About() {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>What is Totemfeed?</h1>

        <section className={styles.section}>
          <p className={styles.intro}>
            One question. Many voices. A shared totem built from anonymous answers.
          </p>
        </section>

        <section className={styles.section}>
          <h2>How it works</h2>
          <div className={styles.steps}>
            <div className={styles.step}>
              <span className={styles.stepNumber}>1</span>
              <div>
                <h3>A question appears</h3>
                <p>Every 25 hours, a new question rises. Simple, thought-provoking, universal.</p>
              </div>
            </div>

            <div className={styles.step}>
              <span className={styles.stepNumber}>2</span>
              <div>
                <h3>You answer anonymously</h3>
                <p>
                  Post for free, or pay 1¢ to enter the prize pool. No account needed.
                  Your answer becomes part of the totem.
                </p>
              </div>
            </div>

            <div className={styles.step}>
              <span className={styles.stepNumber}>3</span>
              <div>
                <h3>Explore randomly</h3>
                <p>
                  Browse answers one by one, in random order. No algorithms, no feeds,
                  no way to game the system. Just serendipity.
                </p>
              </div>
            </div>

            <div className={styles.step}>
              <span className={styles.stepNumber}>4</span>
              <div>
                <h3>Like what resonates</h3>
                <p>
                  When the pot reaches $5 or half the cycle passes, you can like answers.
                  Likes are anonymous. Counts are hidden until the cycle ends.
                </p>
              </div>
            </div>

            <div className={styles.step}>
              <span className={styles.stepNumber}>5</span>
              <div>
                <h3>Winner takes the pot</h3>
                <p>
                  The most-liked paid answer wins 90% of the prize pool. If a free answer
                  wins, the pot rolls over to the next day.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className={styles.section}>
          <h2>Why 25 hours?</h2>
          <p>
            A 25-hour cycle naturally drifts across time zones. No single region always
            gets the best timing. The question belongs to everyone equally.
          </p>
        </section>

        <section className={styles.section}>
          <h2>The rules</h2>
          <ul className={styles.rules}>
            <li><strong>No editing.</strong> Once posted, your answer is final.</li>
            <li><strong>No permalinks to answers.</strong> You can share the totem, not individual answers.</li>
            <li><strong>No like counts during the cycle.</strong> Vote on merit, not popularity.</li>
            <li><strong>Random browsing only.</strong> You can't choose what to see next.</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>Payments & trust</h2>
          <p>
            Payments use the x402 protocol with USDC on Base. Your wallet address is
            encrypted and only used to send winnings. Every payout is recorded in a
            public transparency ledger.
          </p>
          <p>
            We store no personal data. No accounts. No tracking. Just answers and
            anonymous session tokens to prevent abuse.
          </p>
        </section>

        <section className={styles.section}>
          <h2>Built different</h2>
          <p>
            Totemfeed is a response to algorithmic feeds, engagement metrics, and the
            endless scroll. Here, there's one question, finite time, and the beauty of
            not knowing what comes next.
          </p>
          <p>
            Each day's answers form a totem—a collective artifact of human thought,
            then archived forever. No virality. No followers. Just voices.
          </p>
        </section>
      </div>
    </div>
  );
}

